import React from 'react';

export const CompanyContext = React.createContext({
  companyData: {},
  setCompanyData: () => {},
  handleGetCompany: () => {},
});
